import { DateUtils } from "src/utils/date.util";
import { Statistics, StatisticsType } from "../../types/statistics.entity";
import { UserLangCode } from "src/utils/util.types";

export abstract class BaseStatAggregator {
  protected abstract execQuery(statType: StatisticsType, langCode?: UserLangCode): Promise<number>;

  protected createStatistic(type: StatisticsType, count: number, langCode?: UserLangCode): Statistics {
    return {
      count,
      type,
      updatedAt: DateUtils.now(),
      langCode,
    };
  }
  async aggregate(requestedStats: StatisticsType[], langCode?: UserLangCode): Promise<Statistics[]> {
    const results: Statistics[] = [];

    for (const statType of requestedStats) {
      const count = await this.execQuery(statType, langCode);
      results.push(this.createStatistic(statType, count, langCode));
    }

    return results;
  }
}
